define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("ReviewStart", _StateAction, {
		m_tag: "ReviewStart"
	});
});